import * as React from "react"
import { sanitize } from "§/src/utils/functions"

// Internal
import "./_ruler-title.scss"

// Atoms
import ButtonArrow from "§/src/components/atoms/buttons/button-arrow"

const RulerTitle = props => {
  const {
    pretitle,
    subtitle,
    title,
    description,
    titleTag,
    ctaText,
    ctaUrl,
    disableDivider,
    innerHtml,
    ...atomProps
  } = props

  // set atom class
  const atomClassName = "ruler-title"
  var atomClass =
    props.className !== undefined
      ? atomClassName + " " + props.className
      : atomClassName

  // title tag
  // (div, h1, h2 - default h2)
  const TitleTag = titleTag || "h2"

  return (
    <div className={atomClass} {...atomProps}>
      {pretitle && (
        <span
          className="child pretitle mb-1"
          dangerouslySetInnerHTML={{ __html: sanitize(pretitle) }}
        />
      )}
      {title && (
        <div className="title-row">
          <TitleTag className="child title h3 mb-0">
            {innerHtml &&
              <span className="me-sm-3" dangerouslySetInnerHTML={{__html:title}} />
            }
            {!innerHtml &&
              <span className="me-sm-3">{title}</span>
            }
          </TitleTag>
          {ctaText && (
            <ButtonArrow
              dir="end"
              text={ctaText}
              className={
                "d-none d-lg-flex title-cta btn-link btn text-gray ms-auto"
              }
            />
          )}
        </div>
      )}
      {subtitle && (
        <h3
          className="child subtitle mb-3"
          dangerouslySetInnerHTML={{ __html: sanitize(subtitle) }}
        />
      )}
      {description && (
        <p
          className={"description fs-12 pt-2 mb-0"}
          dangerouslySetInnerHTML={{ __html: sanitize(description) }}
        />
      )}
      {!disableDivider && <hr className="h-100" />}
    </div>
  )
}

export default RulerTitle
